import React from 'react'
import classnames from 'classnames'
// @ts-ignore no types
import { Button } from '@adc/ui-adc'
import { graph } from '@adc/constants'
import { useListingContext } from 'common/context/listing'
import { AccountRestrictedAlert } from '../../../../components/accountRestrictedAlert/index'

const BID_BUTTON_LABEL = 'Place Bid'
const PROXY_BID_BUTTON_LABEL = 'Place Proxy Bid'

interface BidButtonProps {
  bidAmount: number
  isProxyBiddingActive: boolean
  containerClassName?: string
  onClick: () => void
  hasError: boolean
}

const BidButton = ({
  containerClassName,
  bidAmount,
  onClick,
  hasError,
  isProxyBiddingActive,
}: BidButtonProps) => {
  const { listing } = useListingContext()

  // defaulting these to true because if we don't get a restriction array back from graph, then don't lock down features
  const proxyBiddingallowed = (listing?.is_current_user_allowed || []).find(
    item =>
      item.action ===
      graph.enums.UserListingAuthorizationAction.ONLINE_PROXY_BIDDING
  )?.allowed
  const regularBiddingallowed = (listing?.is_current_user_allowed || []).find(
    item =>
      item.action ===
      graph.enums.UserListingAuthorizationAction.ONLINE_REGULAR_BIDDING
  )?.allowed
  const isCurrentBiddingTypeRestricted = isProxyBiddingActive
    ? !proxyBiddingallowed
    : !regularBiddingallowed
  const isBidButtonDisabled =
    hasError || !bidAmount || isCurrentBiddingTypeRestricted
  return (
    <div className={classnames('u-stretch', containerClassName)}>
      {isCurrentBiddingTypeRestricted && (
        <AccountRestrictedAlert showIcon={false} />
      )}
      <Button
        role='primary'
        isStretch
        disabled={isBidButtonDisabled}
        elmId='bid_button'
        onClick={onClick}
      >
        {isProxyBiddingActive ? PROXY_BID_BUTTON_LABEL : BID_BUTTON_LABEL}
      </Button>
    </div>
  )
}

export default BidButton
